var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"character-image m-1",class:{
      highligted: _vm.highlight,
      marked_good: _vm.good,
      marked_bad: _vm.bad,
      actual: _vm.size_actual,
      bound100: _vm.size_bound100,
      bound300: _vm.size_bound300,
      selected: _vm.isCharSelected,
    },attrs:{"id":_vm.parentComponent + '_' + _vm.character.id,"src":_vm.character.image.web_url},on:{"click":_vm.onCharacterSelection,"dblclick":function($event){return _vm.$emit('char_double_clicked', _vm.character.id)},"mouseover":_vm.onCharacterHover}}),_c('b-popover',{attrs:{"target":_vm.parentComponent + '_' + _vm.character.id,"title":_vm.character.label,"triggers":"hover","placement":"top","delay":_vm.pop_delay},on:{"hidden":_vm.onHidden}},[(_vm.hoveredCharacter !== null)?_c('CharacterCard',{attrs:{"character":_vm.hoveredCharacter}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }